const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/account-information-service/api-factory');
const serviceFactory = require('../resources/account-information-service/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/psd2aiscservice/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';
  return app => app
    .match(`${p}ais.getConsentRequest[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getConsentRequest(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}ais.getAISConsent[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
        service.getAISConsent(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )
    )) 
    
    .match(`${p}ais.consentUpdate[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
      service.consentUpdate(req.params)
        .then(response => res.value(response))
        .catch(res.error)
    )
  ))
}

module.exports = addRoutes;